import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import GraphCard from 'components/molecules/Cards/GraphCard/GraphCard';

const StyledDealflowTaskBreakdownGraphCard = styled(GraphCard)`
  display: flex;
  flex-direction: column;
  
  .CardContent {
    padding-top: 0;
    padding-bottom: 0;

    .DealflowTaskBreakdownGraphCard {
      &-content {
        height: 100%;
        width: 100%;
        padding: ${props => props.theme.spacing(3)};
        background-color: ${props => props.theme.property('palette.primary.states.selected')};
        border-radius: ${props => props.theme.radius(1)};
      }
    }
  }
  
  ${ComponentStyles}
`;

StyledDealflowTaskBreakdownGraphCard.propTypes = {
  theme: PropTypes.object
};

export default StyledDealflowTaskBreakdownGraphCard;
